
import React, { useMemo } from 'react';
import { Avatar } from "@material-ui/core";
import request from '../api';

const Logo = (props) => {
    const API_BASE = (request?.defaults?.baseURL || '').replace(/\/$/, '');
    const src = useMemo(() => {
        const v = props.logo;
        if (!v) return '';
        if (/^https?:\/\//i.test(v)) return v;
        const encoded = encodeURI(v);
        if (encoded.startsWith('/')) return `${API_BASE}${encoded}`;
        return `${API_BASE}/${encoded}`;
    }, [props.logo]);

    return (
        <Avatar
            className={props.size}
            alt="Logo"
            src={src}
        />
    );
}

export default Logo;
